import Img from 'gatsby-image'
import PropTypes from 'prop-types'
import React from 'react'
import { artDirecting, classes } from '../utils/components'
import Button from './button'
import TextBlock from './text-block'

const ImageBlock = ({
  className,
  titleClass,
  descriptionClass,
  ctaClass,
  titleColorClass,
  descriptionColorClass = 'text-primary',
  title,
  description,
  callToAction,
  image,
  mobileImage,
  vertical = false,
  flip = false,
  altLayout = false,
}) => (
  <div
    className={classes(
      'container flex',
      vertical
        ? 'items-center'
        : `${
            flip ? 'flex-row-reverse' : 'flex-row'
          } md:justify-center md:items-stretch`,
      className
    )}
  >
    <div
      className={classes(
        'flex items-center',
        !vertical && `md:pr-16 ${altLayout ? 'md:w-9/12' : 'md:w-1/2'}`
      )}
    >
      <div
        className={classes(
          'flex flex-col justify-start',
          vertical ? 'items-center' : 'items-start'
        )}
      >
        {title && (
          <h2 className={classes(titleClass, titleColorClass)}>{title}</h2>
        )}
        {description && (
          <TextBlock
            className={classes(
              'mt-10 first:mt-0',
              vertical && 'text-center',
              descriptionClass
            )}
            colorClass={descriptionColorClass}
            text={description}
          ></TextBlock>
        )}
        {callToAction && (
          <Button
            className={classes('hidden mt-8 md:block', ctaClass)}
            title={callToAction.title}
            uri={callToAction.link}
          />
        )}
      </div>
    </div>
    <div
      className={classes(
        vertical
          ? 'mt-16 w-full md:max-w-2/3'
          : `mt-12 md:mt-1 ${altLayout ? 'md:w-3/12' : 'md:w-1/2'}`
      )}
    >
      <Img
        placeholderStyle={{ objectFit: 'contain' }}
        imgStyle={{ objectFit: 'scale-down' }}
        fluid={artDirecting(image, mobileImage)}
      />
      {callToAction && (
        <div className={classes('block self-start mt-8 md:hidden', ctaClass)}>
          <Button title={callToAction.title} uri={callToAction.link} />
        </div>
      )}
    </div>
  </div>
)

ImageBlock.propTypes = {
  className: PropTypes.string,
  titleClasse: PropTypes.string,
  descriptionClasse: PropTypes.string,
  ctaClasse: PropTypes.string,
  titleColorClass: PropTypes.string,
  descriptionColorClass: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.exact({
      childMarkdownRemark: PropTypes.exact({ html: PropTypes.string }),
    }),
  ]),
  callToAction: PropTypes.exact({
    title: PropTypes.string,
    link: PropTypes.string,
  }),
  image: PropTypes.exact({ fluid: PropTypes.object }),
  mobileImage: PropTypes.exact({ fluid: PropTypes.object }),
  vertical: PropTypes.bool,
}

export default ImageBlock
